import React, { useEffect, useState } from "react";
import "../../assets/css/tables.css";
import testBluePng from "../../assets/images/notes/notes.svg";
import { useHistory } from "react-router-dom";

const StudentsTable = ({ studentsData }) => {

    const thumbs = studentsData?.map((file, i) => {
        return (
            <div key={i} className="notesContent mt-2">
                <div className="parentCoursesDiv ">
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={testBluePng} alt="testPng" />
                        </div>
                        <div>
                            <div >
                                <span>{file.email}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    return <div className="divTable mt-5"> {thumbs} </div>;
};

export default StudentsTable;
